import { Directive, ElementRef, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { BlockActionType } from '@core/enums';
import { Page } from '@core/interfaces/page.interface';
import { BlockAction } from '@core/models';
import { ApiInventoryService } from '@core/services/api/api-inventory.service';
import { PageService } from '@core/services/page/page.service';

const allowedAction = [BlockActionType.BUY_NOW, BlockActionType.ADD_TO_CART];

@Directive({
    selector: '[canShow]',
    standalone: false
})
export class CanShowDirective implements OnInit {
  @Input('canShow') action: BlockAction;

  constructor(private element: ElementRef,
              private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
              private pageService: PageService,
              private inventoryService: ApiInventoryService) {
  }

  async ngOnInit() {
    const {actionType} = this.action;
    if (actionType && allowedAction.includes(actionType)) {
      const {modelId} = (this.pageService.page?.value as Page);
      const result = await this.inventoryService.buyIsAvailable(modelId ?? 0);
      if (result) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
